import React from "react";
import { FaPlus } from "react-icons/fa";

const AddButton = ({ onClick, moduleName }) => {
  const auth = JSON.parse(localStorage.getItem("auth")) || {};
  const access = auth?.access || {};

  // Jika user tidak punya akses tambah, jangan render tombol
  if (!access[moduleName]?.includes("tambah")) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center p-2 mb-3 text-white bg-green-600 rounded hover:bg-green-700"
    >
      <FaPlus size={14} />
    </button>
  );
};

export default AddButton;
